
import React, { useEffect } from "react";
import * as styles from './ErrorComponent.style';
import { FeedbackMessage } from "@sapphire-react/lab";
import { useParams, useNavigate } from "react-router-dom";
import { Variables , ErrorTranslation } from "../../api/utils/endpoints";

type ErrorComponentProp = {
    ErrorType: string
}
const ErrorComponent = ({ ErrorType }: ErrorComponentProp) => {
    const { language } = useParams();
    const navigate = useNavigate();
    const allowedLanguages = Variables.allowedLanguageArray;
    const defaultLanguage = Variables.finnishLanguageCode;
    useEffect(() => {
        if (language && !allowedLanguages.includes(language)) {
            switch (ErrorType) {
                case 'PreLogonError':
                    navigate(`/${defaultLanguage}/signin/error` , {replace : true})
                    break;
                case 'PostLogonError':
                    navigate(`/${defaultLanguage}/logon/error` , {replace : true})
                    break;
                case 'NoPageFound':
                    navigate(`/${defaultLanguage}/*` , {replace : true})
                    break;
                default:
                    navigate(`/${defaultLanguage}/error` , {replace : true})
                    break;
            }
        }
    }, [language, navigate, ErrorType, allowedLanguages, defaultLanguage])
    var errorTexts = ErrorTranslation(language as string , ErrorType);
    return (
        <div style={styles.mainDiv}>
            <FeedbackMessage
                type="error"
                heading={errorTexts.MainHeading}
                body={errorTexts.SubHeading}
            />
        </div>
    );
};

export default ErrorComponent;